import { useEffect, useState } from "react";
import { usePageLoading } from "@/hooks/pageLoadingState";
import styles from "./styles/NavigationProgress.module.css";

// Fast loads finish before this and never flash the bar
const SHOW_DELAY_MS = 120;

/** Thin bar at the top of the screen while the next page loads and the old one is still shown. */
export const NavigationProgress = () => {
    const loading = usePageLoading();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!loading) {
            return;
        }
        const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
        return () => {
            clearTimeout(timer);
            setVisible(false);
        };
    }, [loading]);

    if (!loading || !visible) {
        return null;
    }

    return <div className={styles.bar} role="progressbar" aria-label="Laddar sidan" />;
};
